import PropTypes from 'prop-types';

/**
 * Read-only Data Dictionary block for the view-mode field expansion.
 * Primary rows (Business Term, Field Description, Business Definition) always
 * render with an em-dash fallback so the dictionary shape is consistent across
 * fields; secondary rows (Applicable Standard, Data Format) only render when
 * the source carries a meaningful value.
 */

const PRIMARY_ROWS = [
	{ key: 'businessTerm', label: 'Business Term' },
	{ key: 'description', label: 'Field Description' },
	{ key: 'businessDefinition', label: 'Business Definition' },
];

const SECONDARY_ROWS = [
	{ key: 'applicableStandardName', label: 'Applicable Standard' },
	{ key: 'dataFormat', label: 'Data Format' },
];

function isMeaningful(value) {
	if (value == null) return false;
	const s = String(value).trim();
	return s !== '' && s !== 'NA';
}

function renderValue(value) {
	return isMeaningful(value) ? String(value) : '—';
}

export default function DataDictionaryView({ field, fieldId }) {
	const rows = [
		...PRIMARY_ROWS,
		...SECONDARY_ROWS.filter((row) => isMeaningful(field?.[row.key])),
	];

	return (
		<section
			className="dsv-view__section dsv-view__section--data-dict"
			aria-label="Data Dictionary"
			data-testid={`dsv-view-data-dictionary-${fieldId}`}
			style={sectionStyle('#4F5AED')}
		>
			<header style={sectionHeaderStyle}>Data Dictionary</header>
			<dl style={dlStyle}>
				{rows.map((row) => (
					<div key={row.key} style={rowStyle}>
						<dt style={dtStyle}>{row.label}</dt>
						<dd style={ddStyle}>{renderValue(field?.[row.key])}</dd>
					</div>
				))}
			</dl>
		</section>
	);
}

DataDictionaryView.propTypes = {
	field: PropTypes.object.isRequired,
	fieldId: PropTypes.string,
};

function sectionStyle(accent) {
	return {
		borderLeft: `3px solid ${accent}`,
		background: '#f8fafc',
		padding: '10px 14px',
		margin: '8px 0',
		borderRadius: '0 4px 4px 0',
	};
}
const sectionHeaderStyle = {
	fontSize: '11px',
	fontWeight: 600,
	textTransform: 'uppercase',
	letterSpacing: '0.04em',
	color: '#374151',
	marginBottom: '6px',
};
const dlStyle = { display: 'grid', gridTemplateColumns: '160px 1fr', gap: '4px 14px', margin: 0 };
const rowStyle = { display: 'contents' };
const dtStyle = { color: '#6b7280', fontSize: '13px' };
const ddStyle = { margin: 0, fontSize: '13px', color: '#111827', wordBreak: 'break-word' };
